import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Spinner } from "./loandig";
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css'

var swiper = new Swiper(".mySwiper", {
    modules:[Navigation,Pagination],
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
// best treks 
  var swiper = new Swiper(".trekSwiper", {
    modules:[Navigation,Pagination],
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      "@0.00": {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      "@0.75": {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      "@1.00": {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      "@1.50": {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });
  // 
  var featured = new Swiper(".featured", {
    modules:[Navigation,Pagination],
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      "@0.00": {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      "@0.75": {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      "@1.00": {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      "@1.50": {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  const lightbox = GLightbox({
    selector:'.glightbox',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
const lightbox1 = GLightbox({
  selector:'.glightbox1',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});
const lightbox2 = GLightbox({
  selector:'.glightbox2',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});
const lightbox3 = GLightbox({
  selector:'.glightbox3',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});

const lightboxvideo = GLightbox({
  selector:'.glightboxVideo',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});
const lightboxvideo1 = GLightbox({
  selector:'.glightboxVideo1',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});


/************************ CALENDAR *********************************** */
class Calendar {
  constructor() {
      this.years = [2024, 2025, 2026];
      this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

      this.yearTabs = document.getElementById('yearTabs');
      this.monthTabs = document.getElementById('monthTabs');
      this.calendar = document.getElementById('calendar');
      this.dataCalendar = [];

      this.prices = document.getElementById('price')?.innerText ?? null;

      // Fechas no disponibles
      this.isNoAvailable = [{
          anio: 2024,
          mes: 3,
          days: [10, 15, 20, 22]
      }];

      // Set the default active year and month
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      // Generate year tabs
      this.years.forEach(year => {
          const yearTab = this.createTab(year, this.yearTabs, () => {
              this.setActiveTab(yearTab, this.yearTabs);
              this.setup(year, this.getCurrentMonth());
              this.handle_click()

          });
          if (year === currentYear) {
              this.setActiveTab(yearTab, this.yearTabs);

          }
      });

      // Generate month tabs
      this.months.forEach((month, index) => {
          const monthTab = this.createTab(month, this.monthTabs, () => {
              this.setActiveTab(monthTab, this.monthTabs);
              this.setup(this.getCurrentYear(), index + 1);
              this.handle_click()
          });
          if (index + 1 === currentMonth) {
              this.setActiveTab(monthTab, this.monthTabs);
          }
      });

      // Set the default active tab for the current year
      this.setActiveTab(Array.from(this.yearTabs.children).find(tab => tab.innerText === currentYear.toString()), this.yearTabs);

      // Set the default active tab for the current month
      this.setActiveTab(this.monthTabs.children[currentMonth - 1], this.monthTabs);

      // Initial calendar update
      
      this.setup(currentYear, this.getCurrentMonth());

  }
  async setup(currentYear, currentMonth) {
      this.LoadingSpinner(true);
          //  setTimeout( async()=>{
              await this.getApi(currentYear, currentMonth);
              await this.updateCalendar(currentYear, currentMonth);
              await this.handle_click()
          //  },50000)
          


  }

  async getApi(year, month) {
      const data = {
          anio: year,
          mes: month,
          token: 'www.samtravelperu.com',
          type: 8001,
      };
      try {
          const response = await fetch('https://calendar.glampingperutreks.com/api/', {
              method: 'POST', // Specify the HTTP method (POST, GET, etc.)
              headers: {
                  'Content-Type': 'application/json', // Specify content type as JSON
              },
              body: JSON.stringify(data), // Convert data to JSON format
          });

          if (!response.ok) {
              throw new Error(`Network response was not ok: ${response.status}`);
          }

          const apiData = await response.json(); // Parse response as JSON
          // console.log(apiData[1]);
          this.dataCalendar = apiData;
            

      } catch (error) {
          console.error('Error fetching API:', error);
      }
  }

  createTab(text, container, onClick) {
      const tab = document.createElement('div');
      tab.classList.add('tab');
      tab.innerText = text;
      tab.addEventListener('click', onClick);
      container.appendChild(tab);
      return tab;
  }

  setActiveTab(tab, tabContainer) {
      Array.from(tabContainer.children).forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
  }


  getCurrentYear() {
      return parseInt(document.querySelector('#yearTabs .tab.active').innerText);
  }

  getCurrentMonth() {
      const activeYearTab = document.querySelector('#yearTabs .tab.active');
      const currentYear = activeYearTab ? parseInt(activeYearTab.innerText) : new Date().getFullYear();
      const activeMonthTab = document.querySelector('#monthTabs .tab.active');
      const currentMonth = activeMonthTab ? Array.from(document.querySelectorAll('#monthTabs .tab')).indexOf(activeMonthTab) + 1 : new Date().getMonth() + 1;

      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 5);
      // if()

      if (currentDate.getMonth() + 1 > currentMonth || currentDate.getFullYear() > currentYear) {
          // If the current date is more than 5 days away or in the next month, switch to the next month
          const nextMonthTab = document.querySelector(`#monthTabs .tab:nth-child(${currentMonth + 1})`);
          if(currentMonth+1===2 || currentMonth===2){
              const nextMonthTabs = document.querySelector(`#monthTabs .tab:nth-child(${currentMonth + 2})`);

              this.setActiveTab(nextMonthTabs, this.monthTabs);
                 return currentMonth +2;
          }

          if (nextMonthTab) {
              this.setActiveTab(nextMonthTab, this.monthTabs);
              return currentMonth + 1;
          }
      }

      return currentMonth;
  }

  updateCalendar(year, month) {

      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 5); // Sumar 5 días a la fecha actual


      const daysInMonth = new Date(year, month, 0).getDate();
      const firstDayOfWeek = new Date(year, month - 1, 1).getDay();

      const calendar = document.getElementById('calendar');
      calendar.innerHTML = ''; // Limpiar el contenido anterior del calendario

      // Crear filas para los días del mes
      const calendarRow = document.createElement('div');
      calendarRow.classList.add(`panel-container`);
      calendarRow.classList.add(`container-xxl`);
      let currentDay = 1;
      for (let i = 0; i < 6; i++) {
          for (let j = 0; j < 7; j++) {
              const calendarCell = document.createElement('div');
              calendarCell.classList.add('row');
              calendarCell.classList.add('row-calendar');
              calendarCell.classList.add('gy-3');
              if (i === 0 && j < firstDayOfWeek) {
                  // Celdas vacías antes del primer día del mes
                  calendarCell.classList.add('empty-cell');
              } else if (currentDay <= daysInMonth) {
                  // Celdas con números de día (excepto en celdas vacías)
                  const dateText = this.formatDateText(currentDay, month, year);
                  calendarCell.innerHTML = dateText;

                  // Verificar disponibilidad y deshabilitar fechas
                  if (this.isDateUnavailable(year, month, currentDay)) {
                      calendarCell.classList.add('unavailable-date');
                  }
                  // Deshabilitar fechas anteriores a la fecha actual + 5 días
                  const cellDate = new Date(year, month - 1, currentDay);
                  // console.log(cellDate)
                  if (cellDate < currentDate) {
                      calendarCell.classList.add('disabled-date');
                  }

                  currentDay++;
                  calendarRow.appendChild(calendarCell);
              }


          }

          calendar.appendChild(calendarRow);
      }
  }

  isDateUnavailable(year, month, day) {
      const unavailableDate = this.isNoAvailable.find(date => date.anio === year && date.mes === month && date.days.includes(day));
      return unavailableDate !== undefined;
  }
  //  renderiza el calendario
  formatDateText(day, month, year, daysToAdd = 4) {

      const originalDate = new Date(year, month - 1, day);

      const days = originalDate.getDate();
      const months = originalDate.getMonth() + 1; // Adding 1 since months are 0-indexed
      const years = originalDate.getFullYear();
      
      // Agregamos ceros a la izquierda si es necesario
      const formattedDay = days < 10 ? '0' + days : days;
      const formattedMonth = months < 10 ? '0' + months : months;
      
      const formattedDate = `${formattedDay}-${formattedMonth}-${years}`;
  
      //   const  temsdates=new Date(year, month - 1, day );
      // Create a new Date object by adding 5 days to the original date
      const newDate = new Date(originalDate);
      newDate.setDate(originalDate.getDate() + daysToAdd - 1);
   
      const options = { year: 'numeric', month: 'short', day: '2-digit' };
      // Format the original
      const originalDateText = originalDate.toLocaleDateString('en-US', options);
      // new dates
      const newDateText = newDate.toLocaleDateString('en-US', options);
     
      return `
         <div class=" col-8 col-md-6">
            <div>
              <div class="d-block">
                <strong class="fs-sm ">${originalDateText} </strong>
                 <span class=" px-1 px-md-3 text-success"><i class="bi bi-arrow-right"></i></span>
                 <strong class="fs-sm ">${newDateText} </strong>
              </div>
              <span class="text-muted text-muted fs-sm">From Cusco</span>
              <small class="badge ${this.dataCalendar[day] >= 20 ? 'bg-success' : 'bg-danger'} ">
                 ${this.dataCalendar[day] >= 20 ? 'Available' : 'Sold Out'}
              </small>
            </div> 
          </div>
          <div class="col-4 col-md-3">
               <div>
                  <span class="text-muted fs-sm d-block">From</span>
                  <strong class="fs-5">US$${this.prices}</strong>
               </div>
           </div>
           <div class=" col-12 col-md-3">
               <div class="text-center text-md-start">
               <button type="button"  date="${formattedDate}" class="btn btn-dark handle_click  rounded-0 ${this.dataCalendar[day] < 20 ? 'disabled' : ''} letter-spacing-1" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
               Book Now                                </button>

               </div>
           </div>
     `;
  }

  // handle click set global date
  handle_click(){
      const handle_click = document.querySelectorAll('.handle_click');
      handle_click.forEach(el => {
          el.addEventListener('click', () => {
            let dd = el.getAttribute('date');

            window.dateGlobal=dd;
            document.dispatchEvent(new Event('dateGlobalChanged'));
          });
      });
  }
  // a  agrega el load o spin a calendario

  LoadingSpinner(active=true){
      const loadingContainer = `
      <div class="loader">
          <div class="loader-circle"></div>
          <span class="loader-text">Loading...</span>
      </div>`;

      this.calendar.innerHTML=loadingContainer;
  }

}


document.addEventListener('DOMContentLoaded', async () => {
 new Calendar();
});
